import { gql } from "@apollo/client";

export const HomepageDirectReportMeetingFragment = gql`
  fragment HomepageDirectReportMeetingFragment on MeetingNode {
    id
    meetingGroupId
    startDatetime
  }
`;

export const HomepageDirectReportGoalFragment = gql`
  fragment HomepageDirectReportGoalFragment on GoalArtifactNode {
    id
    title
    artifactType
    state
    isStale
    status
    canUpdate {
      permission
    }
    progress
    startValue
    currentValue
    targetValue
    progressType
  }
`;

export default gql`
  ${HomepageDirectReportMeetingFragment}
  ${HomepageDirectReportGoalFragment}
  query getHomepageDirectReportsMetadataQuery(
    $organizationId: Int!
    $directReportIds: [Int]!
    $hasDirectReportIds: Boolean!
    $goalMax: Int!
    $now: DateTime!
    $currentUserId: Int!
  ) {
    directReports: users(
      organizationId: $organizationId
      ids: $directReportIds
    ) @include(if: $hasDirectReportIds) {
      edges {
        node {
          id
          firstName
          name
          avatar
          email
          calendarInsightStatus
          homepageStatus
          goals: ownedGoals(goalState: open, first: $goalMax) {
            totalCount
            edges {
              node {
                id
                ... on GoalArtifactNode {
                  ...HomepageDirectReportGoalFragment
                }
              }
            }
          }
          meetings(
            isFormalOneonone: true
            participants: [$currentUserId]
            startDatetime_Gte: $now
            first: 1
            orderBy: "startDatetime"
          ) {
            edges {
              node {
                ...HomepageDirectReportMeetingFragment
              }
            }
          }
        }
      }
    }
  }
`;
